// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * THIS IS AN AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Any changes you make here may be lost.
 *
 * If you need to make changes, please do so in the original source file, \{project-root\}/sources/custom
 */
export const SDK_VERSION: string = "1.0.0-beta.4";
